<app-modal-generico [modelo]="modalGenerico">
  <div class="table-responsive">
    <app-tablas [page] = "paginaActual" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)" [headers]="headers">
      <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
        <td>{{item.fecha_envio | date:'d/MMM/yyyy, h:mm a' }}</td>
        <td>{{item.numero_radicacion}}</td>
        <td>{{item.tipo_solicitud_descripcion}}</td>
        <td>{{item.desc_tipo_notificacion}}</td>
        <td>{{item.causal_devolucion}}</td>
        <td>{{item.asunto}}</td>
        <td>{{item.usuario_creacion}}</td>
        <td>
          <img src="../../../../../../../assets/icons/ver-eyes.png" class="pointer" alt="" height="30"
            (click)="onCorreoMensaje(item)">
        </td>
        <td>
          <img src="../../../../../../../assets/icons/send-mail.png" class="opacity" alt="" height="30"
            *ngIf="datoSolicitudSharedModel.data.flag_consulta">
          <img src="../../../../../../../assets/icons/send-mail.png" class="opacity" alt="" height="30"
            *ngIf="!datoSolicitudSharedModel.data.flag_consulta && item.numero_intento_envio > 3"
            (click)="onReenviar(item)">
          <img src=" ../../../../../../../assets/icons/send-mail.png" class="pointer" alt="" height="30"
            (click)="onReenviar(item)"
            *ngIf="!datoSolicitudSharedModel.data.flag_consulta && item.numero_intento_envio <= 3">
        </td>
      </tr>
    </app-tablas>
  </div>
  <footer class="text-right p-1">
    <button class="btn btn-primary modal-establecimiento-btn-inicio" (click)="confirm()">Aceptar</button>
  </footer>
</app-modal-generico>